import React, { ComponentProps } from 'react';
import styled, { css } from 'styled-components';
import widthMixin from '../../styles/utils/widthMixin';

type IInputGroupProps = { cols?: number; flexBox?: boolean; withLabel?: boolean; view?: boolean };

const flexBox = (props: IInputGroupProps) => {
  if (props && props.view) {
    return css`
      flex-grow: 1;
      flex-basis: auto;
      width: auto;
      max-width: none;
      padding-right: 0.75rem;
      padding-left: 0.75rem;
      text-align: right;
    `;
  }
  return css`
    ${widthMixin as any};
  `;
};

const fixedWidth = () => {
  return css`
    display: inline-block;
    width: ${(props: IInputGroupProps) => (props.withLabel ? '75%' : '100%')};
  `;
};

const InputGroup = styled.div<IInputGroupProps>`
  font-size: 14px;
  min-height: 34px;
  ${(props) => (props.flexBox ? flexBox(props) : fixedWidth())};
`;

InputGroup.defaultProps = {
  cols: 3 / 4,
  flexBox: true,
  withLabel: false,
};

export default InputGroup;
